module.exports = __webpack_public_path__ + "img/90-9f98db.png";